import { render, staticRenderFns } from "./editVideoDialog.vue?vue&type=template&id=4b22866c&scoped=true"
import script from "./editVideoDialog.vue?vue&type=script&lang=js"
export * from "./editVideoDialog.vue?vue&type=script&lang=js"
import style0 from "./editVideoDialog.vue?vue&type=style&index=0&id=4b22866c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b22866c",
  null
  
)

export default component.exports